module.exports = __webpack_public_path__ + "static/overlay-square-68a12201ec40d65f29b9dd92ffc255fa.png";